import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from './AuthContext';

export function RequireAuth({ children, permissions }) {
    const location = useLocation();
    const { isAuthenticated, hasPermission, loading } = useAuth();

    if (loading) {
        return <div style={{ padding: '2rem', textAlign: 'center' }}>Checking session…</div>;
    }

    if (!isAuthenticated) {
        const redirectTo = encodeURIComponent(`${location.pathname}${location.search}`);
        return <Navigate to={`/login?redirectTo=${redirectTo}`} replace />;
    }

    if (permissions && !hasPermission(permissions)) {
        return <Navigate to="/forbidden" replace />;
    }

    return children;
}
